export default  {	
	data () {
		return {
			active: 1
		}
		
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'proveedor_montura'}) 
	},
  }

